import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getKioskOptions } from '../../../selectors/ui';
import { DELIVERY_TYPE_EMAIL, DELIVERY_TYPE_MOBILE, DELIVERY_TYPE_WILL_CALL } from '../reducers/delivery';
import { getSelectedDeliveryMethodType } from '../../../selectors/delivery';
import Translation from "../../../../shared/Translation";

class KioskDeliveryTitle extends Component {
  render() {

    let message = "checkout__send_a_copy_of_my_tickets";

    if (!this.props.printsTickets) {
        message = "checkout__tickets_will_be_sent_to";
        if (this.props.deliveryType === DELIVERY_TYPE_MOBILE) {
            message = "checkout__tickets_will_be_sent_to_phone";
        }
        if (this.props.deliveryType === DELIVERY_TYPE_EMAIL) {
            message = "checkout__tickets_will_be_sent_to_email";
        }
        if (this.props.deliveryType === DELIVERY_TYPE_WILL_CALL) {
            message = "checkout__tickets_will_be_available_at_will_call";
        }
    }

    return (
        <h4 className="input__label">
          <Translation>{message}</Translation>
        </h4>
    )
  }
}

const mapStateToProps = state => {
    const kioskOptions = getKioskOptions(state);
    return {
        printsTickets: kioskOptions.printReceiptsAndTickets,
        deliveryType: getSelectedDeliveryMethodType(state),
    }
};

KioskDeliveryTitle.propTypes = {
}

export default connect(mapStateToProps)(KioskDeliveryTitle)
